import React from "react";
import './style.css'

const SimpleButton = (props) => {
    return <button onClick={props.onClick} className={`${props.className} base-btn`}>{props.text }{props.icon}</button>
}

export default SimpleButton;